/**
 * @file Contains the definition of maps help with file generator
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import comment from './Win21CustomGeneratorComment';

/**
 * Mapping prefix text to state
 * The key is prefix text for each variable in Response.ini file
 * The value is the state name
 * @type {Map}
 */
export const state2PrefixMap = new Map([
    ['expressMode', 'ExpressMode='],
    ['propertiesFilesOverwrite', 'PropertiesFilesOverwrite='],
    ['enableTracing', 'EnableTracing='],
    ['hideAllDialogs', 'HideAllDialogs='],

    ['forceReboot', 'ForceReboot='],
    ['preventReboot', 'PreventReboot='],
    ['checkTCPIP', 'CheckTCPIP='],
    ['checkIIS', 'CheckIIS='],
    ['createShortcuts', 'CreateShortcuts='],
    ['checkRenameOperations', 'CheckRenameOperations='],
    ['analyticsOverwrite', 'AnalyticsOverwrite='],
    ['tutDeliveryOverwrite', 'TutDeliveryOverwrite='],
    ['backupFiles', 'BackupFiles='],
    ['runConfigWizard', 'RunConfigWizard='],
    ['stopAllServices', 'StopAllServices='],
    ['stopIIS', 'StopIIS='],
    ['enableASPServices', 'EnableASPServices='],
    ['enableASPNETServices', 'EnableASPNETServices='],
    ['showWelcomeScreen', 'ShowWelcomeScreen='],
    ['enterpriseManagerOverwrite', 'EnterpriseManagerOverwrite='],

    ['logFile', 'LogFile='],

    ['hideWelComeDialog', 'HideDialog='],
    ['removeAll', 'RemoveAll='],

    ['hideUserRegistrationDialog', 'HideDialog='],
    ['userFirstName', 'UserFirstName='],
    ['userLastName', 'UserLastName='],
    ['userEmail', 'UserEmail='],
    ['companyName', 'CompanyName='],
    ['licenseKey', 'LicenseKey='],

    ['hideLicenseDetailDialog', 'HideDialog='],

    ['hideSetupExpressDialog', 'HideDialog='],

    ['hideSuiteTargetDialog', 'HideDialog='],
    ['targetDirectory', 'TargetDirectory='],
    ['commonFiles', 'COMMONFILES='],

    ['hideComponentSelectionDialog', 'HideDialog='],
    ['developerVisible', 'DeveloperVisible='],
    ['analystVisible', 'AnalystVisible='],
    ['architectVisible', 'ArchitectVisible='],
    ['serverAdminVisible', 'ServerAdminVisible='],
    ['functionPluginVisible', 'FunctionPluginVisible='],
    ['commandManagerVisible', 'CommandManagerVisible='],
    ['enterpriseManagerVisible', 'EnterpriseManagerVisible='],
    ['objectManagerVisible', 'ObjectManagerVisible='],
    ['integrityManagerVisible', 'IntegrityManagerVisible='],
    ['intelligenceVisible', 'IntelligenceVisible='],
    ['intelligenceOLAPServicesVisible', 'IntelligenceOLAPServicesVisible='],
    ['intelligenceReportServicesVisible', 'IntelligenceReportServicesVisible='],
    [
        'intelligenceDistributionServicesVisible',
        'IntelligenceDistributionServicesVisible=',
    ],
    [
        'intelligenceTransactionServicesVisible',
        'IntelligenceTransactionServicesVisible=',
    ],
    ['webAnalystVisible', 'WebAnalystVisible='],
    ['webProfessionalVisible', 'WebProfessionalVisible='],
    ['webReporterVisible', 'WebReporterVisible='],
    ['webServerASPNETVisible', 'WebServerASPNETVisible='],
    ['webServerJSPVisible', 'WebServerJSPVisible='],
    ['mobileVisible', 'MobileVisible='],
    ['mobileServerASPVisible', 'MobileServerASPVisible='],
    ['mobileServerJSPVisible', 'MobileServerJSPVisible='],
    ['analyticsModulesVisible', 'AnalyticsModulesVisible='],
    ['mdxCubeProviderVisible', 'MDXCubeProviderVisible='],
    ['gisConnectorsVisible', 'GISConnectorsVisible='],
    ['systemManagerVisible', 'SystemManagerVisible='],
    ['telemetryServerVisible', 'TelemetryServerVisible='],
    ['tomcatVisible', 'TomcatVisible='],
    ['libraryWebMobileVisible', 'LibraryWebMobileVisible='],
    ['collaborationVisible', 'CollaborationVisible='],
    ['communityConnectorsVisible', 'CommunityConnectorsVisible='],
    ['platformAnalyticsVisible', 'PlatformAnalyticsVisible='],
    ['certificateStoreVisible', 'CertificateStoreVisible='],
    ['exportVisible', 'ExportVisible='],
    ['microStrategyRepositoryVisible', 'StrategyRepositoryVisible='],
    ['cloudConnectorVisible', 'CloudConnectorVisible='],
    ['storageServiceVisible', 'StorageServiceVisible='],

    ['developerSelect', 'DeveloperSelect='],
    ['analystSelect', 'AnalystSelect='],
    ['architectSelect', 'ArchitectSelect='],
    ['serverAdminSelect', 'ServerAdminSelect='],
    ['functionPluginSelect', 'FunctionPluginSelect='],
    ['commandManagerSelect', 'CommandManagerSelect='],
    ['enterpriseManagerSelect', 'EnterpriseManagerSelect='],
    ['objectManagerSelect', 'ObjectManagerSelect='],
    ['integrityManagerSelect', 'IntegrityManagerSelect='],
    ['intelligenceSelect', 'IntelligenceSelect='],
    ['intelligenceOLAPServicesSelect', 'IntelligenceOLAPServicesSelect='],
    ['intelligenceReportServicesSelect', 'IntelligenceReportServicesSelect='],
    [
        'intelligenceDistributionServicesSelect',
        'IntelligenceDistributionServicesSelect=',
    ],
    [
        'intelligenceTransactionServicesSelect',
        'IntelligenceTransactionServicesSelect=',
    ],
    ['webAnalystSelect', 'WebAnalystSelect='],
    ['webProfessionalSelect', 'WebProfessionalSelect='],
    ['webReporterSelect', 'WebReporterSelect='],
    ['webServerASPNETSelect', 'WebServerASPNETSelect='],
    ['webServerJSPSelect', 'WebServerJSPSelect='],
    ['mobileSelect', 'MobileSelect='],
    ['mobileServerASPSelect', 'MobileServerASPSelect='],
    ['mobileServerJSPSelect', 'MobileServerJSPSelect='],
    ['analyticsModulesSelect', 'AnalyticsModulesSelect='],
    ['mdxCubeProviderSelect', 'MDXCubeProviderSelect='],
    ['gisConnectorsSelect', 'GISConnectorsSelect='],
    ['systemManagerSelect', 'SystemManagerSelect='],
    ['telemetryServerSelect', 'TelemetryServerSelect='],
    ['tomcatSelect', 'TomcatSelect='],
    ['libraryWebMobileSelect', 'LibraryWebMobileSelect='],
    ['collaborationSelect', 'CollaborationSelect='],
    ['communityConnectorsSelect', 'CommunityConnectorsSelect='],
    ['platformAnalyticsSelect', 'PlatformAnalyticsSelect='],
    ['certificateStoreSelect', 'CertificateStoreSelect='],
    ['exportSelect', 'ExportSelect='],
    ['microStrategyRepositorySelect', 'StrategyRepositorySelect='],
    ['cloudConnectorSelect', 'CloudConnectorSelect='],
    ['storageServiceSelect', 'StorageServiceSelect='],

    ['hideServicesRegConfigDialog', 'HideDialog='],

    ['hideRepositoryUpgradeDialog', 'HideDialog='],
    ['repositoryUpgradeConfirm', 'RepositoryUpgradeConfirm='],
    ['repositoryPort', 'RepositoryPort='],
    ['repositoryUsername', 'RepositoryUsername='],
    ['repositoryPassword', 'RepositoryPassword='],

    ['hideRemoteRepositoryConfigDialog', 'HideDialog='],
    ['remoteRepositoryHostname', 'RemoteRepositoryHostname='],
    ['remoteRepositoryPort', 'RemoteRepositoryPort='],
    ['remoteRepositoryUsername', 'RemoteRepositoryUsername='],
    ['remoteRepositoryPassword', 'RemoteRepositoryPassword='],
    ['overrideExistingRepositoryPA', 'OverrideExistingRepositoryPA='],
    ['overrideExistingRepositoryCollab', 'OverrideExistingRepositoryCollab='],
    [
        'overrideExistingRepositoryStorageService',
        'OverrideExistingRepositoryStorageService=',
    ],
    [
        'overwriteExistingDatabaseConnectionInfo',
        'OverwriteExistingDatabaseConnectionInfo=',
    ],

    ['multipleMachineEnvironment', 'MultipleMachineEnvironment='],
    ['serversInCluster', 'ServersInCluster='],

    ['hideTelemetryServerConfigDialog', 'HideDialog='],
    ['telemetryServerCluster', 'TelemetryServerCluster='],
    ['telemetryServerLocalNode', 'TelemetryServerLocalNode='],
    ['telemetryServerRemoteNodes', 'TelemetryServerRemoteNodes='],

    ['hideServerDefinitionSettingDialog', 'HideDialog='],
    ['overwriteServerDefinition', 'OverwriteServerDefinition='],

    ['hideAnalyticsSettingDialog', 'HideDialog='],
    ['overwriteDSN', 'OverwriteDSN='],

    ['hideWebVirtualDirectoryDialog', 'HideDialog='],
    ['webVirtualDirectory', 'VirtualDirectory='],
    ['reconfigureWebVirtualDirectory', 'ReconfigureVirtualDirectory='],

    ['hideMobileVirtualDirectoryDialog', 'HideDialog='],
    ['mobileVirtualDirectory', 'VirtualDirectory='],
    ['reconfigureMobileVirtualDirectory', 'ReconfigureVirtualDirectory='],

    ['mdxVirtualDirectory', 'VirtualDirectory='],
    ['reconfigureMDXVirtualDirectory', 'ReconfigureVirtualDirectory='],

    ['allowBlankURL', 'AllowBlankURL='],

    ['configureExcel', 'ConfigureExcel='],
    ['configurePowerpoint', 'ConfigurePowerpoint='],
    ['configureWord', 'ConfigureWord='],

    ['hideIntelligenceServiceAccountDialog', 'HideDialog='],
    ['isSkipAccountSetting', 'SkipAccountSetting='],
    ['isLogin', 'Login='],
    ['isPassword', 'Password='],
    ['isDomain', 'Domain='],
    ['serviceStartUp', 'ServiceStartUp='],

    ['hideSummaryDialog', 'HideDialog='],

    ['hideFinishDialog', 'HideDialog='],
]);

/**
 * Mapping the comments that should appear before each prefix text
 * The key is prefix text for each variable in Response.ini file
 * The value is the comments content
 * @type {Map}
 */
export const state2CommentMap = new Map([
    ['expressMode', comment.expressMode],
    ['propertiesFilesOverwrite', ''],
    ['enableTracing', ''],
    ['hideAllDialogs', ''],

    ['forceReboot', comment.forceReboot],
    ['preventReboot', ''],
    ['checkTCPIP', ''],
    ['checkIIS', ''],
    ['createShortcuts', ''],
    ['checkRenameOperations', ''],
    ['analyticsOverwrite', ''],
    ['tutDeliveryOverwrite', ''],
    ['backupFiles', ''],
    ['runConfigWizard', ''],
    ['stopAllServices', ''],
    ['stopIIS', ''],
    ['enableASPServices', ''],
    ['enableASPNETServices', ''],
    ['showWelcomeScreen', ''],
    ['enterpriseManagerOverwrite', ''],

    ['logFile', comment.logFile],

    ['hideWelComeDialog', comment.hideWelcomeDialog],
    ['removeAll', comment.removeAll],

    ['hideUserRegistrationDialog', comment.hideUserRegistrationDialog],
    ['userFirstName', comment.userFirstName],
    ['userLastName', comment.userLastName],
    ['userEmail', comment.userEmail],
    ['companyName', comment.companyName],
    ['licenseKey', comment.licenseKey],

    ['hideLicenseDetailDialog', comment.hideLicenseDetailDialog],

    ['hideSetupExpressDialog', comment.hideSetupExpressDialog],

    ['hideSuiteTargetDialog', comment.hideSuiteTargetDialog],
    ['targetDirectory', ''],
    ['commonFiles', comment.commonFiles],

    ['hideComponentSelectionDialog', comment.hideComponentSelectionDialog],
    ['developerVisible', comment.developerVisible],
    ['analystVisible', ''],
    ['architectVisible', ''],
    ['serverAdminVisible', ''],
    ['functionPluginVisible', ''],
    ['commandManagerVisible', ''],
    ['enterpriseManagerVisible', ''],
    ['objectManagerVisible', ''],
    ['integrityManagerVisible', ''],
    ['intelligenceVisible', ''],
    ['intelligenceOLAPServicesVisible', ''],
    ['intelligenceReportServicesVisible', ''],
    ['intelligenceDistributionServicesVisible', ''],
    ['intelligenceTransactionServicesVisible', ''],
    ['webAnalystVisible', ''],
    ['webProfessionalVisible', ''],
    ['webReporterVisible', ''],
    ['webServerASPNETVisible', ''],
    ['webServerJSPVisible', ''],
    ['mobileVisible', ''],
    ['mobileServerASPVisible', ''],
    ['mobileServerJSPVisible', ''],
    ['analyticsModulesVisible', ''],
    ['mdxCubeProviderVisible', ''],
    ['gisConnectorsVisible', ''],
    ['systemManagerVisible', ''],
    ['telemetryServerVisible', comment.telemetryServerVisible],
    ['tomcatVisible', ''],
    ['libraryWebMobileVisible', comment.libraryWebMobileVisible],
    ['collaborationVisible', ''],
    ['communityConnectorsVisible', comment.communityConnectorsVisible],
    ['platformAnalyticsVisible', ''],
    ['certificateStoreVisible', ''],
    ['exportVisible', comment.exportVisible],
    ['microStrategyRepositoryVisible', comment.microStrategyRepositoryVisible],
    ['cloudConnectorVisible', ''],
    ['storageServiceVisible', comment.storageServiceVisible],

    ['developerSelect', comment.developerSelect],
    ['analystSelect', ''],
    ['architectSelect', ''],
    ['serverAdminSelect', ''],
    ['functionPluginSelect', ''],
    ['commandManagerSelect', ''],
    ['enterpriseManagerSelect', ''],
    ['objectManagerSelect', ''],
    ['integrityManagerSelect', ''],
    ['intelligenceSelect', ''],
    ['intelligenceOLAPServicesSelect', ''],
    ['intelligenceReportServicesSelect', ''],
    ['intelligenceDistributionServicesSelect', ''],
    ['intelligenceTransactionServicesSelect', ''],
    ['webAnalystSelect', ''],
    ['webProfessionalSelect', ''],
    ['webReporterSelect', ''],
    ['webServerASPNETSelect', ''],
    ['webServerJSPSelect', ''],
    ['mobileSelect', ''],
    ['mobileServerASPSelect', ''],
    ['mobileServerJSPSelect', ''],
    ['analyticsModulesSelect', ''],
    ['mdxCubeProviderSelect', ''],
    ['gisConnectorsSelect', ''],
    ['systemManagerSelect', ''],
    ['telemetryServerSelect', comment.telemetryServerSelect],
    ['tomcatSelect', ''],
    ['libraryWebMobileSelect', comment.libraryWebMobileSelect],
    ['collaborationSelect', ''],
    ['communityConnectorsSelect', comment.communityConnectorsSelect],
    ['platformAnalyticsSelect', ''],
    ['certificateStoreSelect', ''],
    ['exportSelect', comment.exportSelect],
    ['microStrategyRepositorySelect', comment.microStrategyRepositorySelect],
    ['cloudConnectorSelect', ''],
    ['storageServiceSelect', comment.storageServiceSelect],

    ['hideServicesRegConfigDialog', comment.hideServicesRegConfigDialog],

    [
        'hideRepositoryUpgradeDialog',
        comment.hideRepositoryUpgradeDialog,
    ],
    ['repositoryUpgradeConfirm', ''],
    ['repositoryPort', ''],
    ['repositoryUsername', ''],
    ['repositoryPassword', ''],

    [
        'hideRemoteRepositoryConfigDialog',
        comment.hideRemoteRepositoryConfigDialog,
    ],
    ['remoteRepositoryHostname', ''],
    ['remoteRepositoryPort', ''],
    ['remoteRepositoryUsername', ''],
    ['remoteRepositoryPassword', ''],
    ['overrideExistingRepositoryPA', ''],
    ['overrideExistingRepositoryCollab', ''],
    ['overrideExistingRepositoryStorageService', ''],
    [
        'overwriteExistingDatabaseConnectionInfo',
        comment.overwriteExistingDatabaseConnectionInfo,
    ],
    ['multipleMachineEnvironment', comment.multipleMachineEnvironment],
    ['serversInCluster', comment.serversInCluster],

    [
        'hideTelemetryServerConfigDialog',
        comment.hideTelemetryServerConfigDialog,
    ],
    ['telemetryServerCluster', ''],
    ['telemetryServerLocalNode', comment.telemetryServerLocalNode],
    ['telemetryServerRemoteNodes', comment.telemetryServerRemoteNodes],

    [
        'hideServerDefinitionSettingDialog',
        comment.hideServerDefinitionSettingDialog,
    ],
    ['overwriteServerDefinition', ''],

    ['hideAnalyticsSettingDialog', comment.hideAnalyticsSettingDialog],
    ['overwriteDSN', ''],

    ['hideWebVirtualDirectoryDialog', comment.HideWebVirtualDirectoryDialog],
    ['webVirtualDirectory', ''],
    ['reconfigureWebVirtualDirectory', ''],

    [
        'hideMobileVirtualDirectoryDialog',
        comment.hideMobileVirtualDirectoryDialog,
    ],
    ['mobileVirtualDirectory', ''],
    ['reconfigureMobileVirtualDirectory', ''],

    ['mdxVirtualDirectory', ''],
    ['reconfigureMDXVirtualDirectory', ''],

    ['allowBlankURL', ''],

    ['configureExcel', ''],
    ['configurePowerpoint', ''],
    ['configureWord', ''],

    [
        'hideIntelligenceServiceAccountDialog',
        comment.hideIntelligenceServiceAccountDialog,
    ],
    ['isSkipAccountSetting', ''],
    ['isLogin', ''],
    ['isPassword', ''],
    ['isDomain', ''],
    ['serviceStartUp', ''],

    ['hideSummaryDialog', comment.hideSummaryDialog],

    ['hideFinishDialog', comment.hideFinishDialog],
]);
